module.exports = "<button\r\n  class=\"form-button\"\r\n  type=\"submit\"\r\n  [disabled]=\"disabled\"\r\n>{{ text | translate }}</button>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/components/FormButtonComponent/formButton.component.html
// module id = ./src/app/common/components/FormButtonComponent/formButton.component.html
// module chunks = main